var map = {
	"./admin.js": "b831",
	"./appointment.js": "7cce",
	"./auth.js": "c5e2",
	"./check-auth.js": "3b88",
	"./doctor.js": "2b4f",
	"./finance.js": "fcd0",
	"./guest.js": "d385",
	"./laboratory.js": "a670",
	"./pharmacy.js": "2af4",
	"./procedure.js": "b1c8",
	"./reception.js": "4c90"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "14e5";